import {useMemo} from 'react';
import {connect} from 'react-redux';
import currencies from '../../currencies.json';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

function CurrencyNumber({currency, privacyMode, value, intl}) {

    const v = useMemo(()=>{
        return value ? Number(value) : 0 || 0
    },[value])
    if(privacyMode){
        return '***'
    }
//    return <FormattedNumber style={"currency"} value={value} currency={currency} />
    if(!currency || !currencies[currency.toUpperCase()]) return null;
    const {symbol_native} = currencies[currency.toUpperCase()]
    return symbol_native + intl.formatNumber(Number(parseFloat(String(v)).toFixed(2)))
}

CurrencyNumber.propTypes = {
    value: PropTypes.any.isRequired
};

const mapStateToProps = (state, props) => ({
    currency: props.currency || (state.settings.default_currency || 'USD'),
    privacyMode: state.settings.privacyMode,
});

export default connect(mapStateToProps)(injectIntl(CurrencyNumber));
